/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, imageTypes, replacePXinStringWithEM } from 'utils/styles';



// ===================== ANIMATION : REWARD ONLY ===================== //
const aniRewardOnlyResult = {
    // ~~~~~~~~~~~~~~~~~~~~~ RESULT STATE ~~~~~~~~~~~~~~~~~~~~~ //
    '& .resultelements': {
        height: 'auto',
        zIndex: '2',
        // '& .progressbar.type-result': {
        //     animationName: 'fadeInUp',
        //     animationDelay: '.3s',
        //     animationDuration: '.3s',
        //     animationFillMode: 'forwards'
        // },
        '& .rewardsfeedback': {
            '& .icon': {
                animationName: 'fadeInLeft',
                animationDelay: '.2s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            },
            '& .text': {
                animationName: 'fadeInLeft',
                animationDelay: '.7s',
                animationDuration: '.2s',
                animationFillMode: 'forwards'
            }
        },
        // '& .facebook': {
        //     animationName: 'fadeInUp',
        //     animationDelay: '2.6s',
        //     animationDuration: '.5s',
        //     animationFillMode: 'forwards'
        // },
        // '& .twitter': {
        //     animationName: 'fadeInUp',
        //     animationDelay: '2.9s',
        //     animationDuration: '.5s',
        //     animationFillMode: 'forwards'
        // }
    }
};



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export { aniRewardOnlyResult };